import { associationsTransformer, identificationTokenGraphQLToIdentificationToken, tokenValidationTransformer } from './APITransformer';
import type { Associations, IdentificationToken, TokenValidation } from './Types';

import type { UUID } from '@cobliteam/common-types';

import type { Configuration } from '../..';
import HttpMethod from '../../request/HttpMethod';
import Requester from '../../request/Requester';
import type { IRequest } from '../../request/Types';

export class IdentificationTokenRequester {
  private requester: Requester;

  constructor(configuration: Configuration) {
    this.requester = new Requester(configuration);
  }

  public saveTokenAssociation = (driverId: UUID, identifier: string): Promise<void> => {
    const requestData: IRequest = {
      endpoint: `/driver-identification/drivers/${driverId}`,
      method: HttpMethod.PUT,
      body: JSON.stringify({ cobli_internal_id: identifier }),
    };
    return this.requester.request(requestData).then();
  };

  public tokenValidation = (identifier: string): Promise<TokenValidation> => {
    const requestData: IRequest = {
      endpoint: `/driver-identification/tokens/cobli-internal-ids/${identifier}`,
      method: HttpMethod.GET,
    };
    return this.requester.request(requestData).then((response) => tokenValidationTransformer(response.data));
  };

  public getTokenAssociations = (): Promise<Associations> => {
    const requestData: IRequest = {
      endpoint: '/driver-identification/drivers',
      method: HttpMethod.GET,
    };
    return this.requester.request(requestData).then((response) => associationsTransformer(response.data));
  };

  public getIdentificationTokens = (): Promise<IdentificationToken[]> => {
    const requestData: IRequest = {
      endpoint: '/driver-identification/fleet-tokens',
      method: HttpMethod.GET,
    };
    return this.requester.request(requestData).then((response) => response.data.map(identificationTokenGraphQLToIdentificationToken));
  };
}

export default IdentificationTokenRequester;
